import React, { useState } from 'react';
import { Referral } from '../services/apiService';
import { ApiService } from '../services/apiService';
import { Modal } from './Modal';
import { Button } from './Button';
import FeatherIcon from 'feather-icons-react';

interface SRMessageComposerProps {
  referral: Referral;
  isOpen: boolean;
  onClose: () => void;
}

export const SRMessageComposer: React.FC<SRMessageComposerProps> = ({
  referral,
  isOpen,
  onClose,
}) => {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleClose = () => {
    setMessage('');
    setError(null);
    setSuccess(false);
    onClose();
  };

  const handleSend = async () => {
    const body = message.trim();
    if (!body) {
      setError('Please enter a message for the GP.');
      return;
    }

    setSending(true);
    setError(null);

    try {
      await ApiService.sendSRReferralMessage(referral.id, body);
      setSuccess(true);
      setMessage('');
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : 'Failed to send message. Please try again.';
      setError(errorMsg);
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isLoading={sending}>
      <div className="modal-header">
        <h2>Message GP</h2>
        <Button variant="icon" onClick={handleClose} title="Close">
          <FeatherIcon icon="x" size={20} />
        </Button>
      </div>
      <div className="modal-body">
        <p style={{ marginBottom: '12px', fontSize: '14px', color: '#555' }}>
          Send a message to the referring GP for{' '}
          <strong>
            {referral.patient_first_name} {referral.patient_last_name}
          </strong>
          {referral.sr_referral_number ? ` (${referral.sr_referral_number})` : ''}.
        </p>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={8}
          className="form-control"
          placeholder="Enter your message to the GP..."
          disabled={sending || success}
          style={{ width: '100%', resize: 'vertical' }}
        />
        {error && (
          <div style={{ color: '#c62828', marginTop: '8px', fontSize: '14px' }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{ color: '#2e7d32', marginTop: '8px', fontSize: '14px' }}>
            Message sent successfully.
          </div>
        )}
      </div>
      <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', padding: '1rem' }}>
        <Button variant="secondary" onClick={handleClose} disabled={sending}>
          {success ? 'Close' : 'Cancel'}
        </Button>
        {!success && (
          <Button variant="primary" onClick={handleSend} isLoading={sending} disabled={sending}>
            Send Message
          </Button>
        )}
      </div>
    </Modal>
  );
};
